import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EsimBookingListLayer from "./EsimBookingListLayer";

const EsimBookingListPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="eSIM Booking Management" />
      <EsimBookingListLayer />
    </MasterLayout>
  );
};

export default EsimBookingListPage;
